import React, { useContext } from 'react'

import { Input, Modal, Form } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { MaskedInput } from 'antd-mask-input'
import SL_Date from '../../components/dates/Date';
import { ERegExp } from '../../enums/ERegExp';
import moment from 'moment';
import { displayMessage } from '../../services/helper';

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function CreateMonitor(props) {

    const {setShowLoading, windowHeight} = useContext(GeneralContext)

    const handleCreateMonitor = (values) => {
        setShowLoading(true)

        values.password = "123456" // TODO

        if (values.cpf) {
            if (values.cpf.replace(/\D/g, "")?.length != 11) {
                alert(displayMessage('INVALID_CPF'), 'error')
                setShowLoading(false)
                return
            }
        }

        api.monitor.create(values)
            .then(
                rs => {
                    alert(displayMessage('CREATE_MONITOR_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    props.refreshMonitors()
                }
            ).finally(
                () => {
                    setShowLoading(false)
                    props.handleOnCloseModal()
                }
            )
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('CREATE_MONITOR')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={750}
            style={{ position: 'relative' }}
            bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
        >
            <Form
                className='w-full flex flex-col gap-2 p-5'
                onFinish={handleCreateMonitor}
                layout="vertical"
                requiredMark='optional'
            >
                <div className='font-bold text-lg text-appian-blue text-center'>
                    {displayMessage('MONITOR_DATA')}
                </div>

                <Form.Item
                    label={displayMessage('NAME')}
                    name="first_name"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('FULL_NAME_MANDATORY') },
                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: true, message: displayMessage('NAME_WARNING') },

                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('NAME')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('LAST_NAME')}
                    name="last_name"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('FULL_NAME_MANDATORY') },
                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: true, message: displayMessage('SURENAME_WARNING') },
                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('LAST_NAME')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('CPF')}
                    name="cpf"
                    className={`w-full flex`}
                    rules={[
                        { required: true, pattern: ERegExp.MUST_HAVE_NUMBERS.regexp, message: displayMessage('CPF_MANDATORY') },
                    ]}                >
                    <MaskedInput
                        type="text"
                        size='large'
                        placeholder={displayMessage('CPF') + displayMessage('CPF_EXEMPLE')}
                        className={inputsClassName}
                        mask={'000.000.000-00'}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('EMAIL')}
                    name="email"
                    className={`w-full flex`}
                    rules={[{ required: true, whitespace: true, message: displayMessage('EMAIL_MANDATORY'), type: "email", }]}
                >
                    <Input
                        type="email"
                        size='large'
                        placeholder={displayMessage('EMAIL') + displayMessage('EMAIL_EXEMPLE')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('BIRTHDAY')}
                    name="birth_date"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('BIRTHDAY_MANDATORY') }]}
                >
                    <SL_Date
                        className={inputsClassName}
                        style={{ width: '100%', height: 110 }}
                        placeholder={displayMessage('SELECT_DATE')}
                        format={'DD/MM/YYYY'}
                        disabledDate={(current) => {
                            let customDate = moment().format("YYYY-MM-DD");
                            return current && current >= moment(customDate, "YYYY-MM-DD");
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('IDENTIFICATOR_MONITOR')}
                    name="identificator"
                    className={`w-full flex`}
                    rules={[{
                        required: true,
                        whitespace: true,
                        pattern: ERegExp.MUST_HAVE_LETTERS_OR_NUMBERS.regexp,
                        message: displayMessage('IDENTIFICATOR_MONITOR')
                    }]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('IDENTIFICATOR_MONITOR')}
                        className={inputsClassName}

                    />
                </Form.Item>

                <SL_Button
                    type="primary"
                    size='large'
                    htmlType="submit"
                    className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                >
                    {displayMessage('CREATE_MONITOR')}
                </SL_Button>
            </Form>
        </Modal >
    )
}